import { GetListCommissionsService, GetCommisionsByShopService, GetOrdersByShopService, GetMthodPayService,getDataBankShopService} from "../Infrastructure/Business.service";

export async function GetListCommissionsLogic(zone){
  return await GetListCommissionsService(zone);
}

export async function GetCommissionsByShopLogic(id){
  return await GetCommisionsByShopService(id);
}

export async function GetOrdersByShopLogic(id){
  return await GetOrdersByShopService(id);
}
export async function GetMethodPayLogic(id){
  return await GetMthodPayService(id);
}
export async function getDataBankShopLogic(id){
  return await getDataBankShopService(id);
}